import React from 'react';
import { useTranslation } from 'react-i18next';
import ImageNotSupportedOutlinedIcon from '@mui/icons-material/ImageNotSupportedOutlined';

import Icon from '../../../../icons/Icon';
import UploadButton from '../../../components/upload-button/UploadButton';
import { useProject } from '../../../../context/ProjectContext';
import { PROJECT_VARIANTS } from '../../../../constants';

import scss from './UploadDisclaimer.module.scss';

function UploadDisclaimer() {
  const { t } = useTranslation('activ8');
  const { projectVariant } = useProject();

  return (
    <div className={scss.wrapper}>
      <div className={scss.content}>
        <Icon icon={ImageNotSupportedOutlinedIcon} className={scss.contentIcon} />

        <div className={scss.contentText}>
          <span className={scss.title}>{t('noMediaUploadedYet')}</span>
          <span className={scss.description}>{t('uploadImagesOrVideosToContinueWorkingOnThisProject')}</span>

          {projectVariant === PROJECT_VARIANTS.ADMIN ? <UploadButton /> : null}
        </div>
      </div>
    </div>
  );
}

export default UploadDisclaimer;
